import { Directive } from '@angular/core';

@Directive({
  selector: '[appAssignedAgentsFooter]',
  standalone: true,
})
export class AssignedAgentsFooterDirective {}
